export default __webpack_public_path__ + "static/media/no-activity.75874451.svg";